import React from 'react';
import { AccordionRuleHeader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/AccordionRuleHeader';
import { useOrderSettingsSubheader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/OrderSettingsRule/hooks/useOrderSettingsSubheader';

export interface OrderSettingsRuleHeader {
  isActive: boolean;
}

export function OrderSettingsRuleHeader({
  isActive,
}: OrderSettingsRuleHeader): JSX.Element {
  const { subheader } = useOrderSettingsSubheader();
  return (
    <AccordionRuleHeader
      showSubheader={!isActive}
      header="Order settings"
      subheader={subheader}
    />
  );
}
